import { IconComponent } from './../icon/icon.component';
import { CommonModule } from '@angular/common';
import { Component, input, output, computed } from '@angular/core';

@Component({
  selector: 'lib-button',
  imports: [CommonModule, IconComponent],
  templateUrl: './button.html',
})
export class ButtonComponent {
  size = input<'sm' | 'md'>('md');
  variant = input<'primary' | 'outline'>('primary');
  disabled = input<boolean>(false);
  className = input<string>('');
  iconClass = input<string>('');
  startIcon = input<string | undefined>(undefined);
  endIcon = input<string | undefined>(undefined);
  loading = input<boolean>(false);

  btnClick = output<Event>();

  sizeClasses = computed(() => {
    return this.size() === 'sm' ? 'px-3 py-3 text-sm' : 'px-2 py-4 text-sm';
  });

  variantClasses = computed(() => {
    return this.variant() === 'primary'
      ? 'bg-brand-500 text-white shadow-theme-md hover:bg-brand-600 disabled:bg-brand-300'
      : 'bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/[0.03] dark:hover:text-gray-300';
  });

  disabledClasses = computed(() => {
    return this.disabled() ? 'cursor-not-allowed opacity-50' : '';
  });


  onClick(event: Event) {
    if (!this.disabled()) {
      this.btnClick.emit(event);
    }
  }
}
